import styled from "@emotion/styled";

export const NoMarginParagraph = styled.div`
	margin: 0;
`;

export const SMarginParagraph = styled.div`
	margin: 5px 0;
`;
